









































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import BpcDatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import { Article } from '@accounting/interfaces/article';
import moment from 'moment/moment';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

@Component({
  name: 'bpc-article-impact-modal',
  components: {
    BpcDatePicker,
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class ArticleImpactModal extends Vue {
  @Prop({ type: Object, default: null }) readonly article: Article = null;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'article-impact-modal' }) readonly modalId: string;
  @Prop({ type: Array, default: [] }) readonly articleIds: number[] | string[];
  // Data

  // for accounts
  isProcessingAccounts: boolean = false;
  startDateForAccountUpdate = moment().format('YYYY-MM-DD');
  accountsUpdatedCount: number = 0;
  isAccountsProcessed: boolean = false;

  // for analytics
  isProcessingAnalytics: boolean = false;
  startDateForAnalyticUpdate = moment().format('YYYY-MM-DD');
  analyticsUpdatedCount: number = 0;
  isAnalyticsProcessed: boolean = false;

  // for prices
  isProcessingPrices: boolean = false;
  startDateForPriceUpdate = moment().format('YYYY-MM-DD');
  pricesToRegenerate: number = 0;
  isPricesProcessed: boolean = false;

  public labelInputAttributes = {
    for: 'global__',
    cols: 12,
  };

  get modalTitle(): string {
    if (this.articleIds.length > 0) {
      return this.$t('accounting.article.process_impacts.modal.multiple.title', {
        articleCount: this.articleIds.length,
      }).toString();
    } else {
      return this.$t('accounting.article.process_impacts.modal.single.title', {
        articleName: this.article?.name,
      }).toString();
    }
  }

  get analyticsActivated(): boolean {
    return !!this.$store.getters['centerSettings/analyticsActivated'];
  }

  // Lifecycle
  mounted() {
    console.log('article-impact-modal Mounted !!' + this.showModal);
    if (this.showModal) {
      this.openModal();
    }
  }

  // Methods
  closeModal() {
    this.$emit('close-modal');
    console.log('Hide modal !!');
    this.$bvModal.hide(this.modalId);
  }

  openModal() {
    console.log('Show modal !!');
    this.$bvModal.show(this.modalId);
  }

  processAccounts() {
    this.isProcessingAccounts = true;
    const articleIds = this.articleIds.length > 0 ? this.articleIds : [this.article.id];
    const path = `${this.$bpcApiRouteHelper.getEntityPath('order')}/impact-orders-account`;
    this.$bpcApi
      .post(path, {
        dateFrom: this.startDateForAccountUpdate,
        articleIds: articleIds,
      })
      .subscribe(
        result => {
          this.accountsUpdatedCount = result?.data?.count;
          this.isAccountsProcessed = true;
          this.isProcessingAccounts = false;
        },
        error => {
          this.isProcessingAccounts = false;
        },
      );
  }

  processAnalytics() {
    this.isProcessingAnalytics = true;
    const articleIds = this.articleIds.length > 0 ? this.articleIds : [this.article.id];
    const path = `${this.$bpcApiRouteHelper.getEntityPath('order')}/impact-orders-analytic`;
    this.$bpcApi
      .post(path, {
        dateFrom: this.startDateForAnalyticUpdate,
        articleIds: articleIds,
      })
      .subscribe(
        result => {
          this.analyticsUpdatedCount = result?.data?.count;
          this.isAnalyticsProcessed = true;
          this.isProcessingAnalytics = false;
        },
        error => {
          this.isProcessingAnalytics = false;
        },
      );
  }

  processPrices() {
    this.isProcessingPrices = true;
    const articleIds = this.articleIds.length > 0 ? this.articleIds : [this.article.id];
    const path = `${this.$bpcApiRouteHelper.getEntityPath('order')}/impact-orders-price`;
    this.$bpcApi
      .post(path, {
        dateFrom: this.startDateForPriceUpdate,
        articleIds: articleIds,
      })
      .subscribe(
        result => {
          this.pricesToRegenerate = result?.data?.count;
          this.isPricesProcessed = true;
          this.isProcessingPrices = false;
          this.$emit('processing-impacts-start');
        },
        error => {
          this.isProcessingPrices = false;
        },
      );
  }
}
